'use strict';

wbApp.controller('ActivityReconciliationCtrl', ['$scope', '$modal', '$translate', '$filter', 'messageBoxSvc', 'activitySvc', 'semesterSvc', 'activityReconciliationSvc',
function ($scope, $modal, $translate, $filter, messageBoxSvc, activitySvc, semesterSvc, activityReconciliationSvc) {

    $scope.reconciliationDataRange = 1; // 1 - since last reconciliation, 2 - from last reconciliation
    $scope.fromDate = moment().subtract(1, 'M').startOf('day').toDate();
    $scope.toDate = moment().startOf('day').toDate();

    $scope.$on('refreshData', function (e, data) {
        if ($scope.semesterID && $scope.activityID) {
            loadData();
        }
    });

    $scope.onDataRangeChanged = function () {
        if ($scope.semesterID && $scope.activityID) {
            loadData();
        }
    }

    function loadData() {
        $scope.selectedStudent = {};

        if ($scope.activityID) {
            $scope.students = activityReconciliationSvc.getStudentsByActivity(
                $scope.semesterID,
                $scope.activityID,
                $scope.reconciliationDataRange,
                $scope.fromDate,
                $scope.toDate);
        } else {
            $scope.students.length = 0;
        }
        
        $scope.onStudentSelected(null);

        setUpRemainingExcuses($scope.activityID, null);
    }

    $scope.gridSettings = {
        name: 'students',
        columns: [
            { dataField: 'studentFullName', caption: $translate.instant('TXT_LBL_STUDENT'), dataType: 'string', sortOrder: 'asc', },

            { dataField: 'fullDayRegisteredAttendance', caption: $translate.instant('TXT_FULL_DAYS') + ' ' + $translate.instant('TXT_REGISTERED_ATTENDANCE'), dataType: 'number', width: '70px' },
            { dataField: 'firstPeriodOnlyRegisteredAttendance', caption: $translate.instant('TXT_FIRST_PERIOD_ONLY') + ' ' + $translate.instant('TXT_REGISTERED_ATTENDANCE'), dataType: 'number', width: '70px' },
            { dataField: 'secondPeriodOnlyRegisteredAttendance', caption: $translate.instant('TXT_SECOND_PERIOD_ONLY') + ' ' + $translate.instant('TXT_REGISTERED_ATTENDANCE'), dataType: 'number', width: '70px' },

            { dataField: 'fullDayActualAttendanceNoOneOffs', caption: $translate.instant('TXT_FULL_DAYS') + ' ' + $translate.instant('TXT_REAL_ATTENDANCE'), dataType: 'number', width: '70px' },
            { dataField: 'firstPeriodOnlyActualAttendanceNoOneOffs', caption: $translate.instant('TXT_FIRST_PERIOD_ONLY') + ' ' + $translate.instant('TXT_REAL_ATTENDANCE'), dataType: 'number', width: '70px' },
            { dataField: 'secondPeriodOnlyActualAttendanceNoOneOffs', caption: $translate.instant('TXT_SECOND_PERIOD_ONLY') + ' ' + $translate.instant('TXT_REAL_ATTENDANCE'), dataType: 'number', width: '70px' },

            { dataField: 'fullDayOneOffs', caption: $translate.instant('TXT_FULL_DAYS') + ' ' + $translate.instant('TXT_ONE_OFF_ATTENDANCE'), dataType: 'number', width: '70px' },
            { dataField: 'firstPeriodOnlyOneOffs', caption: $translate.instant('TXT_FIRST_PERIOD_ONLY') + ' ' + $translate.instant('TXT_ONE_OFF_ATTENDANCE'), dataType: 'number', width: '70px' },
            { dataField: 'secondPeriodOnlyOneOffs', caption: $translate.instant('TXT_SECOND_PERIOD_ONLY') + ' ' + $translate.instant('TXT_ONE_OFF_ATTENDANCE'), dataType: 'number', width: '70px' },

            //{ dataField: 'firstPeriodExcuses', caption: $translate.instant('TXT_LBL_FIRST_PERIOD_EXCUSED_SHORT'), dataType: 'number', width: '70px' },
           // { dataField: 'firstPeriodExcusesWithoutFood', caption: $translate.instant('TXT_LBL_FIRST_PERIOD_EXCUSED_WITHOUT_FOOD_SHORT'), dataType: 'number', width: '70px' },
           // { dataField: 'firstPeriodExcusesWithoutComp', caption: $translate.instant('TXT_LBL_FIRST_PERIOD_EXCUSED_NO_COMP_SHORT'), dataType: 'number', width: '70px' },
           // { dataField: 'firstPeriodNonExcuses', caption: $translate.instant('TXT_LBL_FIRST_PERIOD_NOT_EXCUSED_SHORT'), dataType: 'number', width: '70px' },

            //{ dataField: 'secondPeriodRegisteredPresent', caption: $translate.instant('TXT_LBL_SECOND_PERIOD_ATTENDANCE'), dataType: 'number', width: '70px' },
            //{ dataField: 'secondPeriodOneOffs', caption: $translate.instant('TXT_SECOND_PERIOD_ONLY_ONE_OFF_SHORT'), dataType: 'number', width: '70px' },
           // { dataField: 'secondPeriodExcuses', caption: $translate.instant('TXT_LBL_SECOND_PERIOD_EXCUSED_SHORT'), dataType: 'number', width: '70px' },
           // { dataField: 'secondPeriodExcusesWithoutFood', caption: $translate.instant('TXT_LBL_SECOND_PERIOD_EXCUSED_WITHOUT_FOOD_SHORT'), dataType: 'number', width: '70px' },
           // { dataField: 'secondPeriodExcusesWithoutComp', caption: $translate.instant('TXT_LBL_SECOND_PERIOD_EXCUSED_NO_COMP_SHORT'), dataType: 'number', width: '70px' },
           // { dataField: 'secondPeriodNonExcuses', caption: $translate.instant('TXT_LBL_SECOND_PERIOD_NOT_EXCUSED_SHORT'), dataType: 'number', width: '70px' },

            { dataField: 'lunches', caption: $translate.instant('TXT_LBL_ACTIVITY_LUNCH'), dataType: 'number', width: '70px' },
            { dataField: 'firstSnacks', caption: $translate.instant('TXT_FIRST_SNACK'), dataType: 'number', width: '70px' },
            { dataField: 'secondSnacks', caption: $translate.instant('TXT_SECOND_SNACK'), dataType: 'number', width: '70px' },
            { dataField: 'lastReconciliationDate', caption: $translate.instant('TXT_LBL_RECONCILIATIONS'), dataType: 'date', width: '100px' }
        ],
        onRowPrepared: function (e) {
            if (e.rowType == "data") {
                var data = e.component.getKeyByRowIndex(e.rowIndex);
                if (!data.hasAttendance) {
                    e.rowElement.addClass('text-muted');
                }
            }
        }
    }

    //$scope.gridOptions = {
    //    sortInfo: { fields: ['studentFullName'], directions: ['asc'] },
    //    // > 992
    //    columnDefs: [
    //        { field: 'studentFullName', displayName: "TXT_LBL_STUDENT", sort: 'humanName' },
    //        { field: 'firstPeriodRegisteredPresent', displayName: "TXT_LBL_FIRST_PERIOD_ATTENDANCE", width: '70px', smHide: true },
    //        { field: 'firstPeriodExcuses', displayName: "TXT_LBL_FIRST_PERIOD_EXCUSED_SHORT", width: '70px', smHide: true },
    //        { field: 'firstPeriodExcusesWithoutFood', displayName: "TXT_LBL_FIRST_PERIOD_EXCUSED_WITHOUT_FOOD_SHORT", width: '70px', mdHide: true, smHide: true },
    //        { field: 'firstPeriodExcusesWithoutComp', displayName: "TXT_LBL_FIRST_PERIOD_EXCUSED_NO_COMP_SHORT", width: '70px', mdHide: true, smHide: true },
    //        { field: 'firstPeriodNonExcuses', displayName: "TXT_LBL_FIRST_PERIOD_NOT_EXCUSED_SHORT", width: '70px', mdHide: true, smHide: true },

    //        { field: 'secondPeriodRegisteredPresent', displayName: "TXT_LBL_SECOND_PERIOD_ATTENDANCE", width: '70px', smHide: true },
    //        { field: 'secondPeriodExcuses', displayName: "TXT_LBL_SECOND_PERIOD_EXCUSED_SHORT", width: '70px', smHide: true },
    //        { field: 'secondPeriodExcusesWithoutFood', displayName: "TXT_LBL_SECOND_PERIOD_EXCUSED_WITHOUT_FOOD_SHORT", width: '70px', mdHide: true, smHide: true },
    //        { field: 'secondPeriodExcusesWithoutComp', displayName: "TXT_LBL_SECOND_PERIOD_EXCUSED_NO_COMP_SHORT", width: '70px', mdHide: true, smHide: true },
    //        { field: 'secondPeriodNonExcuses', displayName: "TXT_LBL_SECOND_PERIOD_NOT_EXCUSED_SHORT", width: '70px', mdHide: true, smHide: true },

    //        { field: 'lunches', displayName: "TXT_LBL_ACTIVITY_LUNCH", width: '70px' },
    //        { field: 'firstSnacks', displayName: "TXT_FIRST_SNACK", width: '70px', mdHide: true, smHide: true },
    //        { field: 'secondSnacks', displayName: "TXT_SECOND_SNACK", width: '70px', mdHide: true, smHide: true },
    //        { field: 'lastReconciliationDate', displayName: "TXT_LBL_RECONCILIATIONS", cellFilter: "date:'shortDate'", width: '100px' }
    //    ],
    //    disabledField: 'hasAttendance',
    //    noCommandColumn: true
    //};

    $scope.sparklineOpts = {
        width: '100%',
        tooltipFormatter: function (sparkline, options, fields) {
            return $filter('date')(fields.x, 'EEE') + ' ' + $filter('date')(fields.x, 'shortDate') + ' - ' + fields.y;
            //return ' <span style="color: {{color}}">&#9679;</span>{{prefix}}{{x.1}}{{y}}{{suffix}}</span>';
        }
    };
    $scope.remainingExcusesSparklineData = [];

    function setUpRemainingExcuses(activityID, studentID) {
        if (!activityID || !studentID) {
            $scope.remainingExcusesSparklineData = [];
        } else {
            var remaininigExcusesPromise = activityReconciliationSvc.getAvailableExuses($scope.activityID, $scope.selectedStudent.studentID);
            remaininigExcusesPromise.$promise.then(function (data) {
                $scope.remainingExcusesSparklineData = _.map(data.excusesByDate, function (item) {
                    return [item.date, item.noOfExcuses];
                }
                );
            }, function (error) {
                $scope.remainingExcusesSparklineData = [];
            });
        }
    }


    $scope.semesterID;
    $scope.activityID;
    $scope.students = [];
    $scope.selectedStudent = {};

    $scope.$on('activityReconciliationChanged', function (e, data) {
        // Refresh data
        activityReconciliationSvc.refreshByStudentAndActivity(
            $scope.students,
            data.studentID,
            $scope.semesterID,
            $scope.activityID,
            $scope.reconciliationDataRange,
            $scope.fromDate,
            $scope.toDate);

        broadcastStudentSelectionChanged('activityReconciliationChanged');
    });

    semesterSvc.getDefaultAsync().then(function (activeSemester) {
        if (activeSemester) {
            $scope.semesterID = activeSemester.id;
            $scope.onSemesterChange($scope.semesterID);
        } else {
            $scope.semesterID = null;
        }
    });

    $scope.onSemesterChange = function (semesterId) {
        activitySvc.getAllBySemesterIDAsync(semesterId);
    }

    $scope.onActivityChange = function (activityID) {
        loadData();
    }

    function broadcastStudentSelectionChanged(reasonCode) {
        $scope.$broadcast('activityStudentSelectionChanged', {
            semesterID: $scope.semesterID,
            activityID: $scope.activityID,
            studentID: !!$scope.selectedStudent ? $scope.selectedStudent.studentID : null,            
            studentFullName: !!$scope.selectedStudent ? $scope.selectedStudent.studentFullName : null,
            reasonCode: reasonCode
        });
    }

    $scope.onStudentSelected = function (student) {
        $scope.selectedStudent = student;
        setUpRemainingExcuses($scope.activityID, !!student ? student.studentID : null)
        broadcastStudentSelectionChanged('studentSelectionChanged');
    }
    
    $scope.onRowEdit = function (student) {

    }

    $scope.tabs = [
    {
        title: 'TXT_DETAIL',
        template: "activities/activity-reconciliation-tabs/detail.html"
    },
    {
        title: 'TXT_SEC_ATTENDANCE',
        template: "activities/activity-reconciliation-tabs/attendance.html"
    },
    {
        title: 'TXT_LBL_RECONCILIATIONS',
        template: "activities/activity-reconciliation-tabs/reconciliations.html"
    },
    {
        title: 'TXT_LBL_RECURRING_INVOICES',
        template: "activities/activity-reconciliation-tabs/recurring-invoices.html"
    },
    {
        title: 'TXT_LBL_ISSUED_INVOICES',
        template: "activities/activity-reconciliation-tabs/issued-invoices.html"
    }];

    $scope.tabs.activeTab = 0;

    $scope.$watch('tabs.activeTab', function (newValue, oldValue) {
        $scope.$broadcast('activeTabChanged', { activeTab: newValue });
    });

}]);
